<template>
  <div>

    <el-dialog
      @opened="opened"
      title="Report List"
      :visible.sync="editRoleDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="small">

      <div class="dialog-box" v-loading="loadingReport">
        <el-tree
          :data="data"
          :props="props"
          node-key="cardName"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          show-checkbox
          @check-change="handleCheckChange">
        </el-tree>

        <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="saveRole" :loading="loadingSave">Save</el-button>
                <el-button @click="editRoleDialogVisible = false">close</el-button>
        </span>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import util from '@/util/util.js'

  export default {
    components: {
    },
    props:{
      roleInfo: {
        type: Object,
        required: true,
        default:() => {}
      }
    },
    data(){
      return{
        data: [],
        editRoleDialogVisible: false,
        roleDTO:{
        },
        loadingReport: false,
        props: {
          label: 'cardName'
        },
        defaultExpandedKeys: ['MDM Report Center'],//默认展开列表
        defaultCheckedKeys: ['Product Master Data'],//默认展开节点
        chaeckedNode: [], //勾选中的数据
        loadingSave: false,
      }
    },
    watch:{

    },
    computed: {
    },
    created(){
      this.chaeckedNode = []
    },


    methods: {
      handleCheckChange(data,checked) {
        if(checked){ //选中数据
          if(!data.checked){
            data.roleId = this.roleDTO.id
            data.roleName = this.roleDTO.role_name
            if(this.getIndex(this.chaeckedNode,data.cardName) > 0){
              let index = this.getIndex(this.chaeckedNode,data.cardName)
              this.chaeckedNode[index] = data
            } else{
              this.chaeckedNode.push(data)
            }
          }
        } else{
          if(!data.checked){ //一级数据
            if(this.getIndex(this.chaeckedNode,data.cardName) >= 0){
              let index = this.getIndex(this.chaeckedNode,data.cardName)
              this.chaeckedNode.splice(index,1)
            } else{
              this.chaeckedNode.push(data)
            }
          }
        }
      },
      opened(){
        this.roleDTO = util.deepClone(this.roleInfo);
        this.getReport()
      },
      showEditRoleDialog(){

        this.editRoleDialogVisible = true;
      },
      hideEditRoleDialog(){
        this.editRoleDialogVisible = false;
      },
      saveRole(){
        if(this.chaeckedNode.length == 0){
          this.$message.success('Please select Report');
          return
        }
        let url = this.baseAcsUrl + '/acs/role/update-role-report?roleName='+this.roleDTO.role_name;
        this.loadingSave = true;
        this.http.post(url,this.chaeckedNode).then(resp =>{
          this.$message.success('Successful operation ');
          this.editRoleDialogVisible = false;
          this.loadingSave = false;
          this.$emit("saveSuccess");
          this.chaeckedNode = []
          this.data = []
        } ).catch(error => {
          this.$emit("saveFail");
        });
      },
      getReport(){
        this.loadingReport = true
        let url = this.baseAcsUrl + '/acs/role/get-reports-by-role';
        let param = {}
        this.defaultExpandedKeys = []
        this.defaultCheckedKeys = []
        this.chaeckedNode = []
        this.data = []
        param.roleName = this.roleDTO.role_name
        this.http.get(url,param).then(resp =>{
          if(resp.status === 200){
            let data = resp.data
            let menu = ''
            let arr = []
            for(var val of data){
              if(menu != val.menu){ //当menu字段不等于上一个遍历的menu字段的时候
                if(arr.length == 0){ //当数组是空的时候直接插入第一条数据
                  let obj = {}
                  obj.children = []
                  obj.children.push(val)
                  obj.cardName = val.menu
                  obj.checked = true
                  arr.push(obj)
                } else{
                  arr.forEach((item,index) =>{//当数组不是空的时候要遍历根节点是否存在，不存在就插入新的，存在就在这个根节点插入数据
                    if(item.cardName == val.menu){
                      arr[index].children.push(val)
                    } else{
                      let obj = {}
                      obj.children = []
                      obj.children.push(val)
                      obj.cardName = val.menu
                      obj.checked = true
                      arr.push(obj)
                    }
                  })
                }
                menu = val.menu
              } else{ //当menu字段不等于上一个遍历的menu字段的时候直接插入数据
                arr.forEach((item,index) =>{
                  if(item.cardName == val.menu){
                    arr[index].children.push(val)
                  }
                })
                menu = val.menu
              }
              if(val.roleId){
                this.defaultCheckedKeys.push(val.cardName)
                this.defaultExpandedKeys.push(val.menu)
                this.chaeckedNode.push(val)
              }
            }
            console.log(this.chaeckedNode)
            const res = new Map();
            let newArr = this.defaultExpandedKeys.filter((a) => !res.has(a) && res.set(a, 1)) //对默认展开数组进行去重
            let [ ...defaultExpandedKeysIn ] = newArr
            this.defaultExpandedKeys = defaultExpandedKeysIn
            this.data = arr
          }
          this.loadingReport = false;
        } ).catch(error => {
          this.loadingReport = false;
        });
      },
      getIndex(arr,cardName){
        const index = arr.findIndex((item) => {
          return item.cardName === cardName;
        })
        return index
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
  .dialog-box{
    text-align: center;
    .el-button{
      margin-top: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/role/dialog/edit_report.vue